export {default} from 'cl-icons/SvgIcon';
export * from 'cl-icons/SvgIcon';